module.exports = __webpack_public_path__ + "static/media/womens.c8cdce07.jpeg";